// Contenuti legali di Privacy e Cookie policy.
export const UPDATED = "26 ottobre 2026";

const TITOLARE = [
  "Irene Borghi, titolare dell'attività con nome commerciale B Digital Studio.",
  "Sede: Via Kennedy 36, 22060 Novedrate (CO), Italia.",
  "Partita IVA 04076810136 · Codice fiscale BRGRNI89T52B639N.",
  "Email per le richieste privacy: ricetteforkids@gmail.com",
  "Sito web: https://bdigitalstudios.it",
];

export const PRIVACY = {
  title: "Privacy policy",
  desc: "Informativa sul trattamento dei dati personali di B Digital Studio ai sensi del Regolamento UE 2016/679 (GDPR).",
  intro: "Questa informativa spiega quali dati personali vengono trattati quando visiti bdigitalstudios.it o ci contatti, per quali finalità, con quali fornitori e quali diritti puoi esercitare, ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003.",
  sections: [
    { h: "Titolare del trattamento", blocks: [{ list: TITOLARE }, "Non è stato designato un Responsabile della protezione dei dati (DPO), in quanto non obbligatorio per l'attività svolta. Per ogni richiesta puoi rivolgerti direttamente al Titolare."] },
    {
      h: "Dati personali trattati",
      blocks: [
        "Dati forniti tramite il modulo contatti: nome, azienda (facoltativo), indirizzo email e testo del messaggio, insieme alla data e all'ora di invio e di presa visione dell'informativa. Ti chiediamo di non inserire nel messaggio dati particolari (ad esempio relativi alla salute).",
        "Dati di navigazione: i sistemi che rendono disponibile il sito trattano dati tecnici come indirizzo IP, data e ora della richiesta, pagina visitata, tipo di browser e sistema operativo, necessari per erogare le pagine e proteggere il sito da abusi.",
        "Dati comunicati attraverso altri canali: se ci scrivi via email o prenoti una call tramite TidyCal, trattiamo i dati che ci comunichi. In caso di prenotazione tramite TidyCal riceviamo nome, indirizzo email, numero di telefono, data e orario dell'appuntamento ed eventuali note che decidi di aggiungere.",
      ],
    },
    {
      h: "Finalità e basi giuridiche",
      blocks: [
        {
          table: {
            head: ["Finalità", "Base giuridica"],
            rows: [
              ["Rispondere a richieste di contatto, informazioni e preventivi", "Esecuzione di misure precontrattuali su tua richiesta (art. 6.1.b GDPR)"],
              ["Organizzare e svolgere le call conoscitive prenotate", "Misure precontrattuali su tua richiesta (art. 6.1.b GDPR)"],
              ["Gestire il rapporto contrattuale e gli adempimenti fiscali e contabili", "Esecuzione del contratto e obbligo di legge (art. 6.1.b e 6.1.c GDPR)"],
              ["Garantire il funzionamento e la sicurezza del sito", "Legittimo interesse del Titolare (art. 6.1.f GDPR)"],
              ["Accertare, esercitare o difendere un diritto", "Legittimo interesse del Titolare (art. 6.1.f GDPR)"],
            ],
          },
        },
        "Il conferimento dei dati richiesti nel modulo è facoltativo, ma senza di essi non possiamo rispondere alla tua richiesta.",
      ],
    },
    {
      h: "Richieste di contatto e preventivo",
      blocks: [
        "Quando invii il modulo, la richiesta viene salvata nel database del sito e una notifica email con il contenuto della richiesta viene inviata alla casella del Titolare. I dati sono usati solo per risponderti e, se richiesto, preparare un preventivo. Non vengono usati per invii promozionali.",
      ],
    },
    {
      h: "Statistiche e marketing",
      blocks: [
        "Il sito non utilizza strumenti di analisi statistica (come Google Analytics o Google Tag Manager), pixel pubblicitari o di remarketing (come Meta Pixel), né profilazione degli utenti. Non inviamo newsletter o comunicazioni commerciali tramite il sito.",
        "Il fornitore di rete Cloudflare può elaborare dati tecnici aggregati sulle prestazioni e sulla sicurezza del sito, senza finalità di profilazione.",
      ],
    },
    {
      h: "Fornitori e destinatari dei dati",
      blocks: [
        "I dati sono trattati dal Titolare e, per suo conto, da fornitori tecnologici che agiscono come responsabili del trattamento o come titolari autonomi. I dati non vengono diffusi né venduti.",
        {
          table: {
            head: ["Fornitore", "Attività", "Sede e garanzie"],
            rows: [
              ["Emergent", "Piattaforma di sviluppo e hosting del sito e del database delle richieste", "Responsabile del trattamento · eventuali trasferimenti extra SEE con le garanzie previste dal GDPR"],
              ["Cloudflare, Inc.", "DNS, rete di distribuzione e protezione del sito", "USA · Responsabile del trattamento, con le garanzie previste dal GDPR"],
              ["Resend (tramite il servizio email di Emergent)", "Invio della notifica email delle richieste dal modulo", "USA · Responsabile del trattamento, con le garanzie previste dal GDPR"],
              ["Google (Gmail)", "Casella email su cui il Titolare riceve notifiche e richieste", "Possibile trasferimento extra SEE, con le garanzie previste dal GDPR"],
              ["TidyCal", "Prenotazione delle call conoscitive, solo se scegli di usarlo", "Titolare autonomo del trattamento, secondo la propria informativa privacy"],
            ],
          },
        },
      ],
    },
    {
      h: "Trasferimenti fuori dallo Spazio Economico Europeo",
      blocks: [
        "Alcuni fornitori hanno sede negli Stati Uniti. In questi casi il trasferimento avviene sulla base della decisione di adeguatezza della Commissione europea (EU-US Data Privacy Framework) per i fornitori certificati oppure delle Clausole contrattuali standard approvate dalla Commissione, come indicato nelle informative e negli accordi sul trattamento dei dati di ciascun fornitore.",
      ],
    },
    {
      h: "Tempi di conservazione",
      blocks: [
        {
          table: {
            head: ["Dati", "Conservazione"],
            rows: [
              ["Richieste di contatto e preventivi senza contratto", "Fino a 12 mesi dalla conclusione della richiesta"],
              ["Dati relativi a prenotazioni di call senza contratto", "Fino a 12 mesi dall'appuntamento"],
              ["Dati relativi ai rapporti contrattuali", "Per la durata del rapporto e per i 10 anni successivi alla sua conclusione"],
              ["Documentazione fiscale e contabile", "10 anni, come previsto dalla legge"],
              ["Dati tecnici e log di navigazione", "Fino a 12 mesi, salvo necessità di accertare reati o abusi"],
            ],
          },
        },
      ],
    },
    {
      h: "Misure di sicurezza",
      blocks: [
        "Il sito è servito tramite connessione cifrata HTTPS. Il modulo contatti verifica i dati inseriti e include una protezione contro l'invio automatico di spam. L'accesso al database e alla casella email è riservato al Titolare e protetto da credenziali personali.",
      ],
    },
    {
      h: "I tuoi diritti",
      blocks: [
        "Ai sensi degli artt. 15–22 del GDPR puoi chiedere in qualsiasi momento:",
        { list: ["l'accesso ai tuoi dati e una copia degli stessi;", "la rettifica dei dati inesatti o incompleti;", "la cancellazione dei dati;", "la limitazione del trattamento;", "la portabilità dei dati forniti;", "di opporti al trattamento basato sul legittimo interesse;", "la revoca del consenso, dove il trattamento si basi sul consenso, senza pregiudicare i trattamenti già effettuati."] },
        "Per esercitare i tuoi diritti scrivi a ricetteforkids@gmail.com indicando la richiesta. Rispondiamo entro un mese, termine prorogabile di due mesi nei casi più complessi, come previsto dall'art. 12 GDPR.",
        "Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
      ],
    },
    { h: "Minori", blocks: ["Il sito si rivolge ad aziende e professionisti e non è destinato a minori di 14 anni. Non raccogliamo consapevolmente dati di minori."] },
    { h: "Modifiche a questa informativa", blocks: [`L'informativa può essere aggiornata nel tempo. La versione in vigore è sempre pubblicata su questa pagina. Ultimo aggiornamento: ${UPDATED}.`] },
  ],
};

export const COOKIE = {
  title: "Cookie policy",
  desc: "Informativa sui cookie e sulle tecnologie di tracciamento utilizzate dal sito bdigitalstudios.it di B Digital Studio.",
  intro: "I cookie sono piccoli file che un sito salva nel browser. Questa pagina descrive quali cookie e tecnologie simili sono effettivamente presenti su bdigitalstudios.it, nel rispetto delle Linee guida del Garante per la protezione dei dati personali del 10 giugno 2021.",
  sections: [
    { h: "Titolare", blocks: [{ list: TITOLARE }] },
    {
      h: "Cosa utilizza questo sito",
      blocks: [
        "Il sito utilizza solo cookie tecnici, necessari al funzionamento e alla sicurezza. Non utilizza cookie analitici, pubblicitari o di profilazione.",
        { list: ["Nessuno strumento di analisi statistica (Google Analytics, Google Tag Manager).", "Nessun pixel pubblicitario (Meta Pixel o simili).", "Nessun font caricato da Google Fonts: i caratteri sono ospitati direttamente sul sito.", "Nessuna mappa o video incorporato da servizi esterni (Google Maps, YouTube).", "I collegamenti a Instagram e TidyCal sono semplici link: nessun contenuto di questi servizi viene caricato finché non li apri. Da quel momento si applicano le loro informative."] },
      ],
    },
    {
      h: "Elenco dei cookie",
      blocks: [
        {
          table: {
            head: ["Nome", "Fornitore", "Finalità", "Durata", "Categoria", "Consenso"],
            rows: [
              ["__cf_bm", "Cloudflare", "Distingue il traffico umano da quello automatizzato e protegge il sito", "30 minuti", "Tecnico · sicurezza", "Non necessario"],
              ["cf_clearance", "Cloudflare", "Ricorda il superamento di un controllo di sicurezza", "Fino a 1 anno", "Tecnico · sicurezza", "Non necessario"],
            ],
          },
        },
        "Elenco rilevato con un controllo tecnico in data 26 ottobre 2026 sul sito. L'elenco sarà aggiornato in caso di modifiche.",
      ],
    },
    {
      h: "Banner e consenso",
      blocks: [
        "Poiché il sito utilizza esclusivamente cookie tecnici, non è richiesto il consenso preventivo e non viene mostrato un banner cookie. Se in futuro verranno introdotti strumenti di analisi o marketing, saranno attivati solo dopo il tuo consenso, raccolto tramite un apposito banner con le opzioni Accetta, Rifiuta e Personalizza.",
      ],
    },
    {
      h: "Come gestire i cookie dal browser",
      blocks: [
        "Puoi eliminare o bloccare i cookie dalle impostazioni del tuo browser (Chrome, Safari, Firefox, Edge). Il blocco dei cookie tecnici potrebbe impedire il corretto funzionamento di alcune parti del sito.",
      ],
    },
    { h: "Aggiornamenti", blocks: [`Ultimo aggiornamento: ${UPDATED}. Per informazioni sul trattamento dei dati consulta la Privacy policy.`] },
  ],
};
